import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { IconContext } from "@phosphor-icons/react";

import App from "./App";
import "./index.css";
import { initTheme } from "./lib/theme";

// Apply the persisted (or system) theme before first paint to avoid a flash.
initTheme();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* Phosphor section/nav icons default to the duotone two-tone weight — a more
        refined, less generic feel than flat line icons. */}
    <IconContext.Provider value={{ weight: "duotone" }}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </IconContext.Provider>
  </React.StrictMode>,
);
